import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { PDFViewer } from '@react-pdf/renderer';
import { PdfDocument } from '../components/PdfDocument';
import '../../css/pages/customers.css';
import '../../css/pages/dropdown.css';

class ViewPdfDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { state } = this.props.location;
    return (
      <>
        <PDFViewer height="100%" width="100%">
          <PdfDocument schedules={state.pdf_schedules} user={state.user} loan={state.loan} />
        </PDFViewer>
      </>
    );
  }
}

export default ViewPdfDocument;
